const DATA_TEST_IDS = {
  successFragment: 'authentication__common_success-fragment',
} as const;

export default DATA_TEST_IDS;
